import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, share } from 'rxjs/operators';
import { BaseErrorInterceptor } from './base-error-interceptor';

@Injectable()
export abstract class BaseCachedErrorInterceptor extends BaseErrorInterceptor {
  private ongoingHandleError$: Observable<any> | null = null;

  protected handleWithCache(err: HttpErrorResponse, context: any): Observable<any> {
    if (!this.ongoingHandleError$) {
      this.ongoingHandleError$ = this.handleError(err).pipe(
        share(),
        finalize(() => {
          this.ongoingHandleError$ = null;
        })
      );
    }
    return this.ongoingHandleError$;
  }
}
